// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import * as accountActions from '../account/actions';
import * as AccountApi from '../account/api';

import * as coreSelectors from './selectors';
import * as accountSelectors from '../account/selectors';

const styles = theme => ({
  root : {
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#808080 !important",
    '&::label': {
      color: '#808080'
    }
  },
  disabledButton: {
    backgroundColor: 'gray'
  },
  tableHeadFormat: {
    backgroundColor: '#23394C',
    borderBottom: '1px solid white',
  },
  tableContentFormat: {
    backgroundColor: '#23394C'
  }
});

const SmartySDK = require('smartystreets-javascript-sdk');

const SmartyCore = SmartySDK.core;
const LookUp = SmartySDK.usAutocompletePro.Lookup;
const IntlLookUp = SmartySDK.internationalAddressAutocomplete.Lookup;

// US Autocomplete Pro only supports using Embedded Keys
let key = '131977765766150407';
const credentials = new SmartyCore.SharedCredentials(key);
// The appropriate license values to be used for your subscriptions
// can be found on the Subscription page of the account dashboard.
// https://www.smarty.com/docs/cloud/licensing
let clientBuilder = new SmartyCore.ClientBuilder(credentials).withLicenses(["us-autocomplete-pro-cloud"]);
// .withBaseUrl("");
let clientBuilderIntl = new SmartyCore.ClientBuilder(credentials).withLicenses(["international-autocomplete-cloud"]);
let client = clientBuilder.buildUsAutocompleteProClient();
let clientIntl = clientBuilderIntl.buildInternationalAddressAutocompleteClient();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiCore.Slide direction="left" ref={ref} {...props} />;
});


/*
 * User settings
 */

class AddressEdit extends Component {

  state = {
    edit: false,
    plans: false,
    editType: '',
    billingAccountId: null,
    billingAddress1: '',
    billingAddress2: '',
    billingCity: '',
    billingUsState: '',
    billingCountry: 'United States',
    billingUsZip: '',
    billingEmail: '',
    shippingSameAsBilling: 'N',
    screen: '',
    suggestions: [],
    selectedACAddress: null,
    override: false,
    selectedCountry: 'US',
    countryList: [
      {key: 'US', value: 'United States'},
      {key: 'CA', value: 'Canada'},
      {key: 'GB', value: 'United Kingdom'},
      {key: 'DE', value: 'Germany'}
    ],
    newEmailAddress: '',
    localBillingEmails: [],
    originalBillingEmails: [],
    editingEmailId: null,
    editingEmailValue: '',
    showCloseConfirmation: false
  }

  componentDidMount() {
    // Billing emails will be loaded by componentDidUpdate when account is set
  }

  componentDidUpdate(prevProps) {
    // Only update if account has changed
    const currentAccountId = this.props?.account?.accountId;
    const prevAccountId = prevProps?.account?.accountId;
    const stateAccountId = this.state.billingAccountId;
    
    // Update local state when account changes
    if (currentAccountId && currentAccountId !== stateAccountId) {
      let acct = this.props.account;
      this.setState({
        billingAddress1: acct.billingAddress1 || '',
        billingAddress2: acct.billingAddress2 || '',
        billingCity: acct.billingCity || '',
        billingUsState: acct.billingUsState || '',
        billingCountry: acct.billingCountryName || 'United States',
        billingUsZip: acct.billingUsZip || '',
        billingEmail: acct.billingEmail || '',
        billingAccountId: acct.accountId,
        shippingSameAsBilling: acct.shippingSameAsBilling || 'N'
      });
    }
    
    // Fetch billing emails when dialog opens OR account changes
    if (currentAccountId && (
      (this.props.open && !prevProps.open) || 
      (currentAccountId !== prevAccountId)
    )) {
      this.props.queryBillingEmails();
    }
    
    // Copy billing emails to local state when they're loaded or dialog opens
    const billingEmailsChanged = this.props.billingEmails !== prevProps.billingEmails;
    const dialogOpened = this.props.open && !prevProps.open;
    
    if ((billingEmailsChanged || dialogOpened) && this.props.billingEmails) {
      const destinations = Array.isArray(this.props.billingEmails.destinations) 
        ? this.props.billingEmails.destinations.filter(email => email && email.address)
        : [];
      
      // Deep clone to prevent reference issues
      const clonedDestinations = JSON.parse(JSON.stringify(destinations));
      
      this.setState({
        localBillingEmails: clonedDestinations,
        originalBillingEmails: JSON.parse(JSON.stringify(destinations))
      });
    }
  }

  addressClear = () => {
    //Note - we're intentionally not clearing the billingAccountId
    this.setState({billingAddress1: '',
                    billingAddress2:  '',
                    billingCity: '',
                    billingUsState:  '',
                    billingCountry:  'United States',
                    billingUsZip:  '',
                    billingEmail: '',
                    shippingSameAsBilling: 'N'});
  }

  acChange = (field, value, record) => {
    if(this.state.billingCountry !== 'NA'){
      if(this.state.billingCountry === 'United States'){
        var lookup=new LookUp(value);
        lookup.preferRatio = 33;
        lookup.source = "all";
        lookup.maxResults = 10;

        client.send(lookup).then(response=>{
          var newSuggestions=[];
          var count=0;
          response.result.forEach(element => {
            var newElement ={...element};
            newElement.id =count+1; 
            newElement.suggestion = element.streetLine + " "+element.city +" "+element.state+" "+element.zipcode
            count +=1;
            newSuggestions.push(newElement)
          });
          this.setState({suggestions: newSuggestions});
        
        }).catch(console.warn);
      } else {
        lookup=new IntlLookUp(value);
        lookup.preferRatio = 33;
        lookup.source = "all";
        lookup.maxResults = 10;
        const alpha3CountryCodes = {"US":"USA","GB":"GBR","CA":"CAN","DE":"DEU"}
        const alpha2CountryCodes = {"USA":"US","GBR":"GB","CAN":"CA","DEU":"DE"};
        lookup.country = alpha3CountryCodes[this.state.selectedCountry];
        clientIntl.send(lookup).then(response=>{
          var newSuggestions=[];
          var count=0;
          response.result.forEach(element => {
            var newElement ={...element};
            newElement.id =count+1; 
            newElement.suggestion = element.street + " "+element.locality +" "+alpha2CountryCodes[element.countryIso3]+" "+element.postalCode;
            count +=1;
            newSuggestions.push(newElement)
          });
          this.setState({suggestions : newSuggestions})
        
        }).catch(console.warn);
      }
    }
  }
  
  finalAddressChange = (field, value, record) => {
    if(value && this.state.selectedCountry === 'US'){
      if(this.state.suggestions.filter(item => item.suggestion === value).length > 0){
        var address = this.state.suggestions.filter(item => item.suggestion === value)[0]
        this.setState({
          billingAddress1: address.streetLine,
          billingAddress2: '',
          billingCity: address.city,
          billingUsState: address.state,
          billingUsZip: address.zipcode
        })
      }
    }
    if(value && this.state.selectedCountry !== 'US') {
      if(this.state.suggestions.filter(item => item.suggestion === value).length > 0){
        address = this.state.suggestions.filter(item => item.suggestion === value)[0]
        this.setState({
          billingAddress1: address.street,
          billingAddress2: '',
          billingCity: address.locality,
          billingUsState: address.administrativeArea,
          billingUsZip: address.postalCode
        })
      }
    }
  }

  onCloseForm = () => {
    this.setState({
      billingAccountId: null,
      localBillingEmails: [],
      originalBillingEmails: [],
      newEmailAddress: '',
      editingEmailId: null,
      editingEmailValue: '',
      showCloseConfirmation: false
    });
    this.props.onClose();
  }


  handleAddEmail = () => {
    const emailToAdd = this.state.newEmailAddress.trim();
    if (!emailToAdd || !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(emailToAdd)) {
      return;
    }
    
    // Add to local state with a temporary ID
    const newEmail = {
      mailingListDestinationId: `temp-${Date.now()}`, 
      address: emailToAdd,
      name: 'Additional Email',
      isNew: true 
    };
    
    this.setState({
      localBillingEmails: [...this.state.localBillingEmails, newEmail],
      newEmailAddress: ''
    });
  }
  
  handleDeleteEmail = (emailId) => {
    // Remove from local state
    this.setState({
      localBillingEmails: this.state.localBillingEmails.filter(
        email => email.mailingListDestinationId !== emailId
      )
    });
  }

  handleStartEdit = (emailId, currentAddress) => {
    this.setState({
      editingEmailId: emailId,
      editingEmailValue: currentAddress
    });
  }

  handleCancelEdit = () => {
    this.setState({
      editingEmailId: null,
      editingEmailValue: ''
    });
  }

  handleSaveEdit = () => {
    const { editingEmailId, editingEmailValue } = this.state;
    
    // Validate email
    if (!editingEmailValue || !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(editingEmailValue)) {
      return;
    }
    
    // Update in local state
    this.setState({
      localBillingEmails: this.state.localBillingEmails.map(email => 
        email.mailingListDestinationId === editingEmailId
          ? { ...email, address: editingEmailValue, isEdited: true }
          : email
      ),
      editingEmailId: null,
      editingEmailValue: ''
    });
  }
  
  saveBillingEmails = async () => {
    const { originalBillingEmails, localBillingEmails } = this.state;
    const { accountId } = this.props;

    const emailsToDelete = originalBillingEmails.filter(original =>
      !localBillingEmails.some(local =>
        local.mailingListDestinationId === original.mailingListDestinationId
      )
    );
    const emailsToAdd = localBillingEmails.filter(email => email.isNew);
    const emailsToUpdate = localBillingEmails.filter(email => email.isEdited && !email.isNew);

    const call = (fn, ...args) => new Promise((resolve, reject) =>
      fn(resolve, reject, accountId, ...args)
    );

    for (const email of emailsToDelete) {
      await call(AccountApi.deleteBillingEmail, email.mailingListDestinationId);
    }
    for (const email of emailsToUpdate) {
      await call(AccountApi.updateBillingEmail, email.mailingListDestinationId, email.address);
    }
    for (const email of emailsToAdd) {
      await call(AccountApi.addBillingEmail, email.address);
    }

    this.props.queryBillingEmails();
  }

  render() {
    const { open, classes } = this.props;
    
    const emailDestinations = this.state.localBillingEmails;
    
    return (<React.Fragment>
        <MuiCore.Dialog open={open}
                        maxWidth="sm"
                        onClose={() => {
                          this.setState({ showCloseConfirmation: true });
                        }}
                        TransitionComponent={Transition}>
          <MuiCore.DialogTitle>
            Edit Address
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.Grid container spacing={2}>
                
              {/* <MuiCore.Grid item xs={12} >
                <MuiCore.FormControl fullWidth className={classes.formControl}>
                      <MuiCore.InputLabel id="demo-simple-select-label">Country</MuiCore.InputLabel>
                      <MuiCore.Select className={classes.dropdown}
                          labelId="demo-simple-select-label"
                          label="Country"
                          onChange={(event) => {
                              this.setState({
                                billingCountry: event.target.value, 
                                selectedCountry: this.state.countryList.filter(item => item.value === event.target.value)[0].key,
                                billingAddress1: '',
                                billingAddress2: '',
                                billingCity: '',
                                billingUsState: '',
                                billingUsZip: ''
                              })
                          }}
                          value={this.state.billingCountry}>
                          <MuiCore.MenuItem key="NA" value="NA">
                            Not Selected
                          </MuiCore.MenuItem>
                          <MuiCore.MenuItem key="US" value="United States">
                            United States
                          </MuiCore.MenuItem>
                      </MuiCore.Select>
                  </MuiCore.FormControl>
                </MuiCore.Grid> */}
            
                <MuiCore.Grid item xs={12}>
                  <Autocomplete
                    onInputChange={this.acChange}
                    freeSolo
                    options={this.state.suggestions.map((option) => option.suggestion)}
                    onChange={this.finalAddressChange}
                    renderInput={(params) => {
                      params.InputProps.style = {color: '#808080'}
                      params.InputProps.classes = { notchedOutline: classes.notchedOutline }
                      return(<MuiCore.TextField {...params} label="Address Autocomplete"
                      InputLabelProps={{ style : {color: '#808080' }}}
                      />)
                    }}
                  />
                </MuiCore.Grid>
              
                <MuiCore.Grid item xs={8} >
                  <MuiCore.Typography variant='body1' style={{fontSize: 25, fontWeight: 'bold'}}>
                  {this.props.editType === 'billing' ? 'Billing Address' : 'Service Address'}
                  </MuiCore.Typography>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={6} >
                <MuiCore.TextField
                    onChange={(event) => this.setState({billingAddress1: event.target.value})}
                    label='Address line 1'
                    fullWidth
                    required
                    error={this.state.billingAddress1 === ''}
                    helperText={this.state.billingAddress1 === '' ? 'Address is required' : ''}
                    InputProps={{classes: { notchedOutline: classes.notchedOutline },
                      style: { color: '#808080' }
                    }}
                    InputLabelProps={{ style : {color: '#808080' }}}
                    FormHelperTextProps={{ style: { color: '#E5196C' }}}
                    value={this.state.billingAddress1 || ''}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={6} >
                  <MuiCore.TextField
                    onChange={(event) => this.setState({billingAddress2: event.target.value})}
                    label='Address line 2'
                    fullWidth
                    InputProps={{classes: { notchedOutline: classes.notchedOutline },
                      style: { color: '#808080' }
                    }}
                    InputLabelProps={{ style : {color: '#808080' }}}
                    value={this.state.billingAddress2 || ''}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={6}>
                  <MuiCore.TextField
                      onChange={(event) => this.setState({billingCity: event.target.value})}
                      label='City'
                      fullWidth
                      required
                      error={this.state.billingCity === ''}
                      helperText={this.state.billingCity === '' ? 'City is required' : ''}
                      InputProps={{classes: { notchedOutline: classes.notchedOutline },
                        style: { color: '#808080' }
                      }}
                      InputLabelProps={{ style : {color: '#808080' }}}
                      FormHelperTextProps={{ style: { color: '#E5196C' }}}
                      value={this.state.billingCity || ''}/>
                </MuiCore.Grid>
                        
                <MuiCore.Grid item xs={6}>
                  <MuiCore.TextField
                      onChange={(event) => this.setState({billingUsState: event.target.value})}
                      label={this.state.selectedCountry === 'US'? 'State': 'Territory/Province'}
                      fullWidth
                      required
                      error={this.state.billingUsState === ''}
                      helperText={this.state.billingUsState === '' ? (this.state.selectedCountry === 'US' ? 'State is required' : 'Territory/Province is required') : ''}
                      InputProps={{classes: { notchedOutline: classes.notchedOutline },
                        style: { color: '#808080' }
                      }}
                      InputLabelProps={{ style : {color: '#808080' }}}
                      FormHelperTextProps={{ style: { color: '#E5196C' }}}
                      value={this.state.billingUsState || ''}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={12}>
                  <MuiCore.TextField
                      onChange={(event) => this.setState({billingUsZip: event.target.value})}
                      label={this.state.selectedCountry === 'US'? 'Zip': 'Postal Code'}
                      fullWidth
                      required
                      error={this.state.billingUsZip === ''}
                      helperText={this.state.billingUsZip === '' ? (this.state.selectedCountry === 'US' ? 'Zip is required' : 'Postal Code is required') : ''}
                      InputProps={{classes: { notchedOutline: classes.notchedOutline },
                        style: { color: '#808080' }
                      }}
                      InputLabelProps={{ style : {color: '#808080' }}}
                      FormHelperTextProps={{ style: { color: '#E5196C' }}}
                      value={this.state.billingUsZip || ''}/>
                </MuiCore.Grid>

                <MuiCore.Grid item xs={6}>
                  <MuiCore.TextField
                    onChange={(event) => this.setState({billingEmail: event.target.value})}
                    label='Billing Email'
                    type='email'
                    fullWidth
                    required
                    error={this.state.billingEmail === '' || (this.state.billingEmail && !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.billingEmail))}
                    helperText={
                      this.state.billingEmail === '' 
                        ? 'Email required' 
                        : (this.state.billingEmail && !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.billingEmail) 
                            ? 'Invalid email format' 
                            : '')
                    }
                    InputProps={{classes: {notchedOutline: classes.notchedOutline},
                      style: { color: '#808080' }
                    }}
                    InputLabelProps={{ style : {color: '#808080' }}}
                    FormHelperTextProps={{ style: { color: '#E5196C' }}}
                    value={this.state.billingEmail || ''}/>
                </MuiCore.Grid>

                {/* Additional billing emails section */}
                <MuiCore.Grid item xs={12}>
                  <MuiCore.Typography variant='body2' style={{marginTop: 16, marginBottom: 8, color: '#808080'}}>
                    Additional Billing Emails
                  </MuiCore.Typography>
                </MuiCore.Grid>

                {/* List of additional emails */}
                {emailDestinations.map((email, index) => (
                  <React.Fragment key={email.mailingListDestinationId || `email-${index}`}>
                    <MuiCore.Grid item xs={10}>
                      <MuiCore.TextField
                        label={`Additional Email ${index + 1}`}
                        fullWidth
                        disabled={this.state.editingEmailId !== email.mailingListDestinationId}
                        value={
                          this.state.editingEmailId === email.mailingListDestinationId 
                            ? this.state.editingEmailValue 
                            : email.address || ''
                        }
                        onChange={(e) => this.setState({editingEmailValue: e.target.value})}
                        error={
                          this.state.editingEmailId === email.mailingListDestinationId &&
                          this.state.editingEmailValue &&
                          !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.editingEmailValue)
                        }
                        helperText={
                          this.state.editingEmailId === email.mailingListDestinationId &&
                          this.state.editingEmailValue &&
                          !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.editingEmailValue)
                            ? 'Invalid email format'
                            : ''
                        }
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                          style: { color: '#808080' }
                        }}
                        InputLabelProps={{ style : {color: '#808080' }}}
                        FormHelperTextProps={{ style: { color: '#E5196C' }}}
                      />
                    </MuiCore.Grid>
                    <MuiCore.Grid item xs={2} style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                      {this.state.editingEmailId === email.mailingListDestinationId ? (
                        // Show Check and Close icons when editing
                        <>
                          <MuiCore.IconButton 
                            onClick={this.handleSaveEdit}
                            style={{color: '#4CAF50'}}
                            size="small"
                          >
                            <CheckIcon />
                          </MuiCore.IconButton>
                          <MuiCore.IconButton 
                            onClick={this.handleCancelEdit}
                            style={{color: '#808080'}}
                            size="small"
                          >
                            <CloseIcon />
                          </MuiCore.IconButton>
                        </>
                      ) : (
                        // Show Edit and Delete icons normally
                        <>
                          <MuiCore.IconButton 
                            onClick={() => this.handleStartEdit(email.mailingListDestinationId, email.address)}
                            style={{color: '#7E2062'}}
                            size="small"
                          >
                            <EditIcon />
                          </MuiCore.IconButton>
                          <MuiCore.IconButton 
                            onClick={() => this.handleDeleteEmail(email.mailingListDestinationId)}
                            style={{color: '#E5196C'}}
                            size="small"
                          >
                            <DeleteIcon />
                          </MuiCore.IconButton>
                        </>
                      )}
                    </MuiCore.Grid>
                  </React.Fragment>
                ))}
                
                {/* Add New Email Section (only show if less than 10 additional emails) */}
                {(emailDestinations.length < 10) && (
                  <React.Fragment>
                    <MuiCore.Grid item xs={10}>
                      <MuiCore.TextField
                        label='Add Additional Email'
                        fullWidth
                        type='email'
                        placeholder='email@example.com'
                        value={this.state.newEmailAddress}
                        onChange={(e) => this.setState({newEmailAddress: e.target.value})}
                        error={
                          this.state.newEmailAddress &&
                          !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.newEmailAddress)
                        }
                        helperText={
                          this.state.newEmailAddress &&
                          !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.newEmailAddress)
                            ? 'Invalid email format'
                            : ''
                        }
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                          style: { color: '#808080' }
                        }}
                        InputLabelProps={{ style : {color: '#808080' }}}
                        FormHelperTextProps={{ style: { color: '#E5196C' }}}
                      />
                    </MuiCore.Grid>
                    <MuiCore.Grid item xs={2} style={{display: 'flex', alignItems: 'center'}}>
                      <MuiCore.Button
                        variant="contained"
                        size="small"
                        disabled={!this.state.newEmailAddress || !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.newEmailAddress)}
                        onClick={this.handleAddEmail}
                        style={{
                          backgroundColor: this.state.newEmailAddress && /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.newEmailAddress) ? '#7E2062' : '#cccccc',
                          color: '#fff'
                        }}
                      >
                        Add
                      </MuiCore.Button>
                    </MuiCore.Grid>
                  </React.Fragment>
                )}
                
                {/* Show message when limit reached */}
                {(emailDestinations.length >= 10) && (
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.Typography variant='caption' style={{color: '#E5196C', fontStyle: 'italic'}}>
                      Maximum of 10 additional emails reached
                    </MuiCore.Typography>
                  </MuiCore.Grid>
                )}
              
                {/* {this.props.editType === 'billing' && <MuiCore.Grid item xs={6}>
                  <MuiCore.Typography variant='body1'>
                    Service same as billing ?
                    <MuiCore.Checkbox sx={{color: '#fff','&.Mui-checked': {color: '#fff'}}} onChange={(event) => this.setState({shippingSameAsBilling: event.target.checked ? 'Y' : 'N'})}/>
                  </MuiCore.Typography>
                </MuiCore.Grid>} */}
              
            </MuiCore.Grid>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button style={
              this.state.billingAddress1 === '' ||
              this.state.billingCity === '' ||
              this.state.billingCountry === '' ||
              this.state.billingUsState === '' ||
              this.state.billingUsZip === '' ||
              this.state.billingEmail === '' ||
              !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(this.state.billingEmail)
            ? {
              pointerEvents: 'none'
            } : {
              cursor: 'auto'
            }}  onClick={async () => {
              // First save billing emails
              await this.saveBillingEmails();
              
              // Then save address
              this.props.saveEditAccount({
                accountId: this.props.accountId,
                editType: this.props.editType,
                billingAddress1: this.state.billingAddress1,
                billingAddress2: this.state.billingAddress2,
                billingCity: this.state.billingCity,
                billingUsState: this.state.selectedCountry === 'US' ? this.state.billingUsState : '',
                billingTerritory: this.state.selectedCountry !== 'US' ? this.state.billingUsState : '',
                billingCountry: this.state.selectedCountry,
                billingUsZip: this.state.selectedCountry === 'US' ? this.state.billingUsZip : '',
                billingPostalCode: this.state.selectedCountry !== 'US' ? this.state.billingUsZip : '',
                billingEmail: this.state.billingEmail,
                billingCountryName: this.state.billingCountry,
                shippingSameAsBilling: this.state.shippingSameAsBilling,
                shippingAddress1: this.state.billingAddress1,
                shippingAddress2: this.state.billingAddress2,
                shippingCity: this.state.billingCity,
                shippingUsState: this.state.selectedCountry === 'US' ? this.state.billingUsState : '',
                shippingTerritory: this.state.selectedCountry !== 'US' ? this.state.billingUsState : '',
                shippingCountry: this.state.selectedCountry,
                shippingUsZip: this.state.selectedCountry === 'US' ? this.state.billingUsZip : '',
                shippingPostalCode: this.state.selectedCountry !== 'US' ? this.state.billingUsZip : '',
              });
              
              this.setState({
                edit: false,
                editType: '',
                billingAddress1: '',
                billingAddress2: '',
                billingCity: '',
                billingUsState: '',
                billingCountry: 'NA',
                billingUsZip: '',
                billingEmail: '',
                shippingSameAsBilling: 'N',
              });
              
              this.onCloseForm();
            }}>Save</MuiCore.Button>
            <MuiCore.Button onClick={() => {
              this.setState({ showCloseConfirmation: true });
            }}>
              Cancel
            </MuiCore.Button>
            <MuiCore.Button onClick={() => {
              this.addressClear();
            }}>
              Clear Fields
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        
        {/* Confirmation Dialog */}
        <MuiCore.Dialog
          open={this.state.showCloseConfirmation}
          onClose={() => this.setState({ showCloseConfirmation: false })}
          maxWidth="xs"
        >
          <MuiCore.DialogContent style={{ padding: '30px' }}>
            <MuiCore.Typography style={{ fontSize: 16 }}>
              Do you wish to exit without saving?
            </MuiCore.Typography>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button onClick={() => this.setState({ showCloseConfirmation: false })} style={{ color: '#ffffff' }}>
              No
            </MuiCore.Button>
            <MuiCore.Button onClick={() => { this.setState({ showCloseConfirmation: false }); this.onCloseForm(); }} style={{ color: '#ffffff' }}>
              Yes
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
        
      </React.Fragment>      
    );
  }
}

AddressEdit.propTypes = {
  open : PropTypes.bool.isRequired,
  onClose : PropTypes.func.isRequired,
}

AddressEdit.defaultProps = {
  open : false,
}


const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    accountId: accountSelectors.getAccountId(state),
    account: accountSelectors.getAccount(state),
    billingEmails: accountSelectors.getBillingEmails(state)
  });
};

const mapDispatchToProps = {
  setAccountId: accountActions.setAccountId,
  saveEditAccount: accountActions.saveEditAccount,
  queryAccount: accountActions.queryAccount,
  queryBillingEmails: accountActions.queryBillingEmails,
  addBillingEmailAction: accountActions.addBillingEmailAction,
  updateBillingEmailAction: accountActions.updateBillingEmailAction,
  deleteBillingEmailAction: accountActions.deleteBillingEmailAction
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddressEdit));

